export enum SortOptions {
  LATEST = "Latest",
  TOP_RATED = "Top Rated",
  OLDEST = "Oldest",
  NAME = "Name",
}

export enum FilterKeys {
  ALL = "All",
  VISIBILITY = "visibility",
  MODERATION_STATUS = "moderation_status",
  MODERATION_REPORT_STATUS = "moderationReportStatus",
}
export enum FilterOptions {
  ALL = "All",
  PUBLIC = "public",
  PRIVATE = "private",
  HIDDEN = "hidden",
  UNDER_REVIEW = "pending",
  ACTION_REQUIRED = "fix_required",
}

export interface IOptions {
  label: string;
  value: string;
  key?: FilterKeys;
}
